import { render } from "./videoMonitor.vue?vue&type=template&id=6dfc8246&scoped=true"
import script from "./videoMonitor.vue?vue&type=script&lang=js"
export * from "./videoMonitor.vue?vue&type=script&lang=js"

import "./videoMonitor.vue?vue&type=style&index=0&id=6dfc8246&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfc8246"]])

export default __exports__